<template>
    <div class="d-phone-input">
        <DInput
            :id="`${id}_prefix`"
            v-model="regionInput"
            type="phone"
            :placeholder="phoneCountryCodePlaceholder"
            maxlength="4"
            add-input-classes="bg-light"
            :is-valid="isValid"
            @update:value="updateValue"
        />
        <DInput
            :id="`${id}_number`"
            v-model="numberInput"
            type="phone"
            placeholder="12345678910"
            maxlength="21"
            add-input-classes="bg-light"
            :is-valid="isValid"
            :invalid-feedback="invalidFeedbackData"
            @update:value="updateValue"
        />
    </div>
</template>

<script>

import { parsePhoneNumberWithError, ParseError, isPossiblePhoneNumber } from 'libphonenumber-js'
// Documentation: https://www.npmjs.com/package/libphonenumber-js
export default {
    name: 'DPhoneInput',
    props: {
        modelValue: {
            type: String,
            default: null
        },
        phoneCountryCodePlaceholder: {
            type: String,
            default: ''
        },
        isValid: {
            type: Boolean,
            default: () => true
        },
        invalidFeedback: {
            type: String,
            default: () => null
        },
        id: {
            type: String,
            default: ''
        },
        preserveFormatting: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    data () {
        return {
            regionInput: '',
            numberInput: '',
            invalidFeedbackData: this.invalidFeedbackData
        }
    },
    computed: {
    },
    mounted () {
        this.setValue()
    },
    methods: {
        updateValue () {
            this.$emit('update:modelValue', this.regionInput + '' + this.numberInput)
        },
        setValue () {
            if (!this.modelValue) {
                this.regionInput = this.phoneCountryCodePlaceholder

                return
            }

            if (isPossiblePhoneNumber(this.modelValue)) {
                // probably correct format, try to parse:
                try {
                    const phoneNumberObject = parsePhoneNumberWithError(this.modelValue)

                    if (phoneNumberObject) {
                        this.regionInput = '+' + phoneNumberObject.countryCallingCode
                        this.numberInput = this.preserveFormatting
                            ? this.modelValue.replace(this.regionInput, '')
                            : phoneNumberObject.nationalNumber
                    } else {
                        // parsing failed, just fill second input
                        this.regionInput = ''
                        this.numberInput = this.modelValue
                    }
                } catch (error) {
                    if (error instanceof ParseError) {
                        this.invalidFeedbackData = this.getErrorMsg(error.message)
                    } else {
                        this.invalidFeedbackData = this.getErrorMsg(error)
                    }
                }
            } else {
                try {
                    parsePhoneNumberWithError(this.modelValue)
                } catch (error) {
                    if (error instanceof ParseError) {
                        this.invalidFeedbackData = this.getErrorMsg(error.message)
                    } else {
                        this.invalidFeedbackData = this.getErrorMsg(error)
                    }
                }

                // not identifiable format, just fill second input
                this.regionInput = ''
                this.numberInput = this.modelValue
            }
            this.updateValue()
        },
        getErrorMsg (error) {
            if (error === 'NOT_A_NUMBER') {
                return this.__('validation.phone_number.not_a_number')
            }
            if (error === 'INVALID_COUNTRY') {
                return this.__('validation.phone_number.invalid_country')
            }
            if (error === 'TOO_SHORT') {
                return this.__('validation.phone_number.too_short_number')
            }
            if (error === 'TOO_LONG') {
                return this.__('validation.phone_number.too_long_number')
            }

            return error
        }
    }
}
</script>

<style lang="scss">
.d-phone-input {
    display: grid;
    grid-template-columns: 90px 1fr;
    grid-gap: 15px;
}
</style>
